import React, { useContext } from "react";
import Typewriter from "typewriter-effect";
import { context } from "../../utility/ContextProvider";

function Type() {
  const {textcolour}=useContext(context)
  return (
    <Typewriter className={textcolour}
      options={{
        strings: [
          "Developer with a Passion for Innovation",
          "Continuous Deep Learner and Tech Enthusiast",
          "Expert MERN Stack Developer Crafting Seamless Experiences",
          "Versatile Full Stack Developer Building Comprehensive Solutions",
          "Collaborative Team Collaborator and Cross-functional Contributor",
          "Eager to Connect, Learn, and Collaborate!",
        ],
        autoStart: true,
        loop: true,
        deleteSpeed: 50,
      }}
    />
  );
}

export default Type;